<template>
  <transition name="fade">
    <router-view/>
  </transition>
</template>

<script>
import 'normalize.css';
export default {};
</script>

<style lang="scss">
@import './assets/stylesheets/fonts';
html,
body {
  height: 100%;
  -moz-font-feature-settings: 'kern';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media only screen and (-webkit-min-device-pixel-ratio: 1.25),
  only screen and (min-device-pixel-ratio: 1.25),
  only screen and (min-resolution: 200dpi),
  only screen and (min-resolution: 1.25dppx) {
  html,
  body {
    -webkit-font-smoothing: subpixel-antialiased;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.flickity-button,
.flickity-button:hover {
  background: hsla(0, 0%, 100%, 0.2) !important;
}
.flickity-prev-next-button.previous {
  top: 6%;
}
.flickity-prev-next-button.next {
  top: 93%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.title-project {
  position: absolute;
  left: 110px;
  top: 50%;
  transform: translateY(-50%);
  mix-blend-mode: overlay;
  z-index: 10;
  font-size: 60px;
}
.position-top-left {
  position: fixed;
  top: 20px;
  left: 20px;
  transform: translateX(-100%);
  z-index: 15;
  mix-blend-mode: difference;
  @media (min-width: 769px) {
    top: 76px;
    left: 32px;
    mix-blend-mode: normal;
  }
  .logo-liisa {
    transform: rotate(-90deg);
    transform-origin: right top;
  }
  a {
    color: #000;
    font-size: 22px;
    font-weight: 700;
    text-decoration: none;
    display: inline-block;
  }
  img {
    width: 62px;
  }
}
.position-bottom-right {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 15;
  mix-blend-mode: difference;
  @media (min-width: 769px) {
    mix-blend-mode: normal;
    bottom: 56px;
    right: 32px;
  }
  img {
    width: 116px;
  }
}
</style>
